/**
 * smsDuyuruService.js — SMS ile önemli duyuru (backlog #643, backend #642). E-posta posta listelerinin toplu gönderimi (#585 / #571) gibi iki adım: ÖNİZLEME (yazmaz)
 * ve ONAYLI GÖNDERİM (bir iş: ilerleme izlenir, durdurulabilir).
 *
 * ⚠ SÖZLEŞME VARSAYIMDIR: #642 henüz yazılmadı. Yollar ve alanlar o görevin metninden çıkarıldı ve e-posta toplu gönderimiyle hizalandı; backend yazılırken ya buna uyulur
 * ya da bu dosya ve testi birlikte güncellenir.
 *
 *   alıcı gövdesi `recipients`: { source: 'LIST' | 'USERS' | 'PERSONS' | 'BOTH', list_id?, users?: { only_active, fuar_id? },
 *                                 persons?: { fuar_id?, firma_query?, salon_query? } }   — her numara bir kez; geçerli cep numarası olmayanlar sayılır, gönderilmez
 *   POST   /sms/announcements/preview { recipients, text_tr, text_en? , urgent }  →
 *            { recipients, users, persons, without_mobile, duplicates, parts_tr, parts_en, unit_price, estimated_cost, currency, balance, enough, quiet_hours }
 *   POST   /sms/announcements         { recipients, text_tr, text_en?, urgent, informational: true, confirmed_count } → 202 { job_id }
 *            (informational: "bu mesaj bilgilendirmedir, ticari değildir" onayı — kategori HIZMET'tir, ticari mesaj yok; confirmed_count önizlemedeki alıcı sayısıdır)
 *   GET    /sms/announcements/{jobId} →
 *            { job_id, state: RUNNING | DONE | CANCELLED | STOPPED, total, sent, failed, blocked, unknown, cost, stopped_reason, started_at, finished_at }
 *   DELETE /sms/announcements/{jobId} → durdurur (gitmeyenler gitmez, gidenler geri alınmaz)
 *   GET    /sms/announcements?page=&size= → geçmiş: [{ id, created_at, created_by_name, text_tr, recipients, sent, failed, cost, state }]
 * İzin: yeni bir izin (#629 D7; burada `sms.duyuru.gonder` varsayıldı). Hata mesajı backend'in `message` alanıdır; 409: başka bir iş sürüyor, 402/400: bakiye ya da sayı uyuşmuyor.
 */
import axios from 'axios';
import { JAVA_BACKEND_API_URL, getAuthHeader } from '../Components/Contexts/BackendConstants';
import { smsHatasi } from './smsAyarService';

const BASE = `${JAVA_BACKEND_API_URL}/sms/announcements`;

async function al(istek) {
  try {
    return (await istek()).data;
  } catch (error) {
    throw smsHatasi(error);
  }
}

export const KAYNAKLAR = ['LIST', 'USERS', 'PERSONS', 'BOTH'];
export const IS_BITTI = ['DONE', 'CANCELLED', 'STOPPED'];

/** Formdan sunucunun beklediği alıcı gövdesi: yalnız seçili kaynağın alanları, boş süzgeç alanları atılır. */
export function aliciGovdesi({ kaynak, listeId, yalnizEtkinKullanici, fuarId, firma, salon }) {
  const out = { source: kaynak };
  if (kaynak === 'LIST') out.list_id = listeId ? Number(listeId) : null;
  if (kaynak === 'USERS' || kaynak === 'BOTH') {
    out.users = { only_active: !!yalnizEtkinKullanici };
    if (fuarId) out.users.fuar_id = Number(fuarId);
  }
  if (kaynak === 'PERSONS' || kaynak === 'BOTH') {
    out.persons = {};
    if (fuarId) out.persons.fuar_id = Number(fuarId);
    if (firma && firma.trim()) out.persons.firma_query = firma.trim();
    if (salon && salon.trim()) out.persons.salon_query = salon.trim();
  }
  return out;
}

export const previewAnnouncement = ({ recipients, textTr, textEn, urgent }) =>
  al(() => axios.post(`${BASE}/preview`, { recipients, text_tr: textTr, text_en: textEn && textEn.trim() ? textEn : null, urgent: !!urgent }, { headers: getAuthHeader() }));

export const sendAnnouncement = ({ recipients, textTr, textEn, urgent, confirmedCount }) =>
  al(() => axios.post(BASE, {
    recipients, text_tr: textTr, text_en: textEn && textEn.trim() ? textEn : null, urgent: !!urgent, informational: true, confirmed_count: confirmedCount,
  }, { headers: getAuthHeader() }));

export const getAnnouncementJob = (jobId) => al(() => axios.get(`${BASE}/${jobId}`, { headers: getAuthHeader() }));
export const cancelAnnouncementJob = (jobId) => al(() => axios.delete(`${BASE}/${jobId}`, { headers: getAuthHeader() }));
export async function listAnnouncements({ page = 0, size = 10 } = {}) {
  const veri = await al(() => axios.get(BASE, { headers: getAuthHeader(), params: { page, size } }));
  return Array.isArray(veri) ? veri : Array.isArray(veri?.content) ? veri.content : [];
}
